import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { AddNotesService } from "../../services/AssembliesService";
import SkeletonContainer, { getSkeletonHeight } from "../../loaders/SekletonContainer";
import { ContainerWrapper } from "../common/GlobalElements/Wrappers";
import { BodySmall } from "../common/GlobalElements/Typography";
import { StandardButton } from "../common/GlobalElements/StandardButton";
import { tokens } from "../../public/tokens";

export default function CreateNotesLesson(props) {
  const [loading, setLoading] = useState(false);
  const {timestamp, refresh, setRefresh}=props
  const { lessonItemId } = props.props;
  const history = useHistory();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      intake_id: "",
      notes_content: "",
      assemblies_items_id: "",
      video_start_duration: 0,
      video_end_duration: 0,
    },
    validationSchema: Yup.object({
      notes_content: Yup.string().required("Note is required"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const formInputs = new FormData();
      formInputs.append("video_start_duration", timestamp?.startDuration);
      formInputs.append("video_end_duration", timestamp?.pauseDuration);
      formInputs.append("intake_id", props.subjectId);
      formInputs.append("notes_content", values.notes_content);
      formInputs.append("assemblies_items_id", lessonItemId);
      AddNotesService(formInputs)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Created!",
            text:"Note has been created successfully.",
            timer: 3000,
            onOpen: function () {
              Swal.showLoading();
            },
          })
          .then(function (result) {
            setLoading(false);
            if (result.dismiss === "timer") {
              props.closeAddNotes(false)
            }
            setRefresh(Date.now())
          });
        })
        .catch((error) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: error?.message,
            timer: 3000,
            onOpen: function () {
              Swal.showLoading();
            },
          })
        });
    },
  });

  return (
    <>
      {loading && <SkeletonContainer height={getSkeletonHeight(10)} />}
      {!loading && <ContainerWrapper className="Tickets-main-wrap">
        <form onSubmit={formik.handleSubmit}>
          <div className="row">
            <div className="col-xl-12 form-group">
              <BodySmall fontWeight={tokens.typography.fontWeights.bold} as="label" htmlFor="textArea12" title="Add New Note">Add New Note</BodySmall>
              <textarea
                type="text"
                id="textArea12"
                name="notes_content"
                className={
                  "note-input form-control" +
                  (formik.errors.notes_content &&
                    formik.touched.notes_content
                    ? " is-invalid"
                    : "")
                }
                title="Add any notes you would like to take."
                placeholder="Add any notes you would like to take."
                value={formik.values.notes_content}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.notes_content &&
                formik.errors.notes_content && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.notes_content}
                  </div>
                )}
            </div>
            <div className="form-group atttach-file m-0 col-12 d-flex ">
              <div className="" title="Save"> 
                <StandardButton
                  type="submit"
                  disabled={loading}
                >
                  {loading && <i className="fas fa-cog fa-spin"></i>}{" "}
                  <i className="fal fa-save"></i>
                  Save
                </StandardButton>
              </div>
              <div className="" title="Cancel">
                <StandardButton
                  variant="danger"
                  onClick={() => props.closeAddNotes(false)}
                >
                  <i className="fal fa-times m-0"></i>
                  Cancel
                </StandardButton>
              </div>
            </div>
          </div>
        </form>
      </ContainerWrapper>
    } 
    </>
  );
}
